import React from 'react';
import { SocialProps } from '@/types';

const Footer: React.FC<SocialProps> = ({ socials }) => {
  return (
    <footer className="py-8 border-t border-gray-800 bg-gray-900/50">
      <div className="max-w-7xl mx-auto px-6 text-center">
        {socials.map((social, index) => {
          const IconComponent = social.icon;
          return (
            <a href={social.link} target="_blank" rel="noopener noreferrer" className="mb-3 flex justify-center">
              <IconComponent className="w-8 h-8" />
            </a>
          );
        })}
        <span className="text-gray-400">
          © 2019 Stephen Wolfe. Systems Architect & Cloud Solutions Expert.
        </span>
      </div>
    </footer>
  );
};

export default Footer;